// extracted by mini-css-extract-plugin
var _1 = "Cursor-module__animateUploadProgressBarWidth--JBsbd";
var _2 = "Cursor-module__animatedBackground--wh3Pn";
var _3 = "Cursor-module__color1--GDSn9";
var _4 = "Cursor-module__color2--EpHq9";
var _5 = "Cursor-module__color3--fNhho";
var _6 = "Cursor-module__color4--HT1Cl";
var _7 = "Cursor-module__color5--LoNiG";
var _8 = "Cursor-module__color6--OWTjq";
var _9 = "Cursor-module__container--d8LBn";
var _a = "Cursor-module__cursor--Zy_3L";
var _b = "Cursor-module__nameLabel--GnmSR";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "color1", _4 as "color2", _5 as "color3", _6 as "color4", _7 as "color5", _8 as "color6", _9 as "container", _a as "cursor", _b as "nameLabel" }
